import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders } from '@angular/compiler/src/core';
import { SidePanelService } from './side-panel.service';
import { OffCanvasComponent } from './off-canvas/off-canvas.component';
import { SidePanelWrapperComponent } from './side-panel-wrapper/side-panel-wrapper.component';

@NgModule({
  declarations: [
    OffCanvasComponent,
    SidePanelWrapperComponent
  ],
  imports: [
    CommonModule,

  ],
  entryComponents: [
    OffCanvasComponent,
    SidePanelWrapperComponent
  ]
})
export class SidePanelModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: SidePanelModule,
      providers: [
        SidePanelService
      ]
    };
  }
}
